import React, { Component } from 'react'
import Image from 'gatsby-image'
import Link from 'gatsby-link'
import { navigateTo } from 'gatsby-link'
import styled from 'styled-components'

import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import Right from '../assets/right-arrow.png'
import Left from '../assets/left-arrow.png'

const ProjectSliderComponent = styled(Slider)`
  .slideWrapper {
    position: relative;
    @media screen and (min-width: 1088px) {
      margin: 0 5px;
    }
  }
  .slick-arrow {
    z-index: 15;
    width: 64px;
    height: 64px;
    @media screen and (max-width: 768px) {
      width: 24px;
      height: 24px;
    }
    img {
      opacity: 0.4;
      transition: opacity 0.5s ease;
      @media screen and (max-width: 768px) {
        opacity: 1;
      }
    }
    &:hover {
      img {
        opacity: 1 !important;
      }
    }
  }
  .slick-list {
    z-index: 1;
  }

  .slick-prev {
    position: absolute;
    @media screen and (max-width: 1279px) {
      left: -85px;
    }
    left: 200px;

    &::before {
      content: ' ';
    }
  }
  .slick-next {
    position: absolute;
    @media screen and (max-width: 1279px) {
      right: -85px;
    }
    right: 200px;
    &::before {
      content: ' ';
    }
  }
`

const SlideBackground = styled.div.attrs({
  red: props => props.color.red,
  green: props => props.color.green,
  blue: props => props.color.blue,
})`
  .image {
    padding-top: 25%;
  }
  .slideContent {
    position: relative;
    min-height: 20rem;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }
  .slideWrapper {
    position: relative;

    .gradient-1 {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      z-index: 1;
      opacity: 1;
      transition: opacity 1.5s ease;

      background: rgb(
        ${props => props.red},
        ${props => props.green},
        ${props => props.blue}
      );
      background: linear-gradient(
        0deg,
        rgba(
            ${props => props.red},
            ${props => props.green},
            ${props => props.blue},
            1
          )
          0%,
        rgba(
            ${props => props.red},
            ${props => props.green},
            ${props => props.blue},
            0.9
          )
          70%,
        rgba(0, 0, 0, 0) 100%
      );
    }
    .gradient-2 {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      z-index: 1;
      opacity: 0;
      transition: opacity 1.5s ease;

      background: rgb(
        ${props => props.red},
        ${props => props.green},
        ${props => props.blue}
      );
      background: linear-gradient(
        0deg,
        rgba(
            ${props => props.red},
            ${props => props.green},
            ${props => props.blue},
            1
          )
          0%,
        rgba(
            ${props => props.red},
            ${props => props.green},
            ${props => props.blue},
            1
          )
          25%,
        rgba(0, 0, 0, 0) 70%
      );
    }
  }

  .active {
    .gradient-1 {
      opacity: 0 !important;
      z-index: 0;
      transition: opacity 1.5s ease;
    }
    .gradient-2 {
      opacity: 1 !important;
      z-index: 0;
      transition: opacity 1.5s ease;
    }
  }

  .project-link {
    &::hover {
      padding-bottom: 2rem;
    }
  }
`

const PrevArrow = ({ className, onClick, style }) => (
  <div
    onClick={onClick}
    className={className}
    style={{ ...style, display: 'block' }}
  >
    <img src={Left} alt="" />
  </div>
)
const NextArrow = ({ className, onClick, style }) => (
  <div
    onClick={onClick}
    className={className}
    style={{ ...style, display: 'block' }}
  >
    <img src={Right} alt="" />
  </div>
)

class ProjectSlider extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      activeSlide: 0,
    }
  }
  render() {
    var settings = {
      infinite: true,
      speed: 500,
      padding: 20,
      centerPadding: '300px',
      className: 'center',
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      nextArrow: <NextArrow />,
      prevArrow: <PrevArrow />,
      beforeChange: (current, next) => this.setState({ activeSlide: next }),
      responsive: [
        {
          breakpoint: 1279,
          settings: {
            centerPadding: '0px',
            dots: true,
          },
        },
      ],
    }
    return (
      <ProjectSliderComponent {...settings} style={{ cursor: 'pointer' }}>
        {this.props.slides.map((slide, index) => (
          <SlideBackground
            key={slide.id}
            className="slideContainer"
            color={slide.accent}
          >
            <div
              className={
                this.state.activeSlide == index
                  ? 'active slideWrapper image'
                  : 'slideWrapper image '
              }
            >
              <div className="gradient-1" />
              <div className="gradient-2" />
              <Image
                className=""
                resolutions={slide.thumbnail.resolutions}
                style={{
                  position: 'absolute',
                  left: 0,
                  top: 0,
                  width: '100%',
                  height: '100%',
                  zIndex: -1,
                }}
              />
              <div
                className="button-overlay"
                style={{
                  position: 'absolute',
                  top: 0,
                  right: 0,
                  padding: '20px',
                }}
              >
                <Link
                  className="button is-small is-marginless has-text-weight-bold"
                  to={'/work/' + slide.slug}
                  style={{
                    margin: ' 10px 0px 0px 0px',
                    color: '#fff ',
                    backgroundColor: `rgba( ${slide.accent.red}, ${
                      slide.accent.green
                    }, ${slide.accent.blue}, .6  )`,
                    borderColor: `${slide.accent.hex}`,
                  }}
                >
                  View Project
                </Link>
              </div>
              <div className="slideContent">
                <div className="card-content">
                  <p className="title is-size-3-widescreen is-size-1-desktop is-size-5-mobile has-text-white ">
                    {slide.title}
                  </p>
                  <p className="subtitle is-size-5-widescreen has-text-white ">
                    {slide.subtitle}{' '}
                  </p>
                </div>
              </div>
            </div>
          </SlideBackground>
        ))}
      </ProjectSliderComponent>
    )
  }
}

export default ProjectSlider



// WEBPACK FOOTER //
// ./src/components/slider.js